<template>
  <div class="success-stories-area pb-75">
    <div class="container">
      <div class="section-title">
        <span class="top-title">Our Recent Works</span>
        <h2 title="We connect brands with celebrities and influencers for powerful digital campaigns.">MyCelebrity is a celebrity and influencer agency that specialized in elevating brands through impactful collaborations.</h2>
      </div>

     <!-- <router-link
        to="/success-stories"
        class="read-more mt-3 d-inline-block"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="200"
      >
        VIEW MORE
        <img src="../../assets/images/icon-right-red.png" alt="icon-right-red" />
      </router-link> -->

      <div
        class="row align-items-center"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="300"
      >
        <div
          class="col-lg-3 col-sm-6"
          v-for="post in instagramPosts"
          :key="post.id"
        >
          <div class="success-single-item style-two transition-y">
            <!-- Instagram Embed -->
            <iframe
              :src="`https://www.instagram.com/p/${post.code}/embed`"
              width="100%"
              height="480"
              frameborder="0"
              allowfullscreen
              scrolling="no"
              allowtransparency="true"
              class="instagram-frame"
            ></iframe>
            <div class="success-content d-flex align-items-center justify-content-between">
              <div>
                <h3 title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" >{{ post.title }}</h3>
                <span>{{ post.designation }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SuccessStories",
  data() {
    return {
      instagramPosts: [
        { id: 1, code: "DFpSO-QPQJR" },
        { id: 2, code: "DFpR8AwPG4M" },
        { id: 3, code: "CqFrwpPoYDV" },
        { id: 4, code: "DEHG-wCPsX2" },
        { id: 5, code: "DEHJCq-v9JT" },
        { id: 6, code: "DIGKuOmPr-Q" },
        { id: 7, code: "DHFjgJAPCxI" },
        { id: 8, code: "C6YPRt-PrTW" },
        { id: 9, code: "C4sgVwvPswU" },
        { id: 10, code: "C1n-09vvo8-" },
        { id: 11, code: "DHs5f62vAlm" },
        { id: 12, code: "DEMTWZKvnHI" },
        { id: 13, code: "DENX51dvFYe" },
        { id: 14, code: "CqvXUQfo5TT" },
        { id: 15, code: "CYsfaNXIZZP" },
        { id: 16, code: "C6VoVQUvZgr" },
      ],
    };
  },
});
</script>

<style lang="scss" scoped>
.success-stories-area.bg {
  background: linear-gradient(
    180deg,
    #fff 0%,
    rgba(255, 150, 150, 0.27) 0%,
    rgba(255, 255, 255, 0) 100%
  );
}

.success-single-item {
  position: relative;
  margin-bottom: 30px;
  padding: 0 12px; // Horizontal spacing for left and right

  .instagram-frame {
    border-radius: 20px;
    margin-bottom: 20px;
    width: 100%;
  }

  .success-content {
    margin-top: 15px;

    h3 {
      font-size: 22px;
      color: var(--headingColor);
    }

    span {
      color: var(--bodyColor);
    }
  }
}

.success-content {
  margin-left: 106px;

  .object {
    margin-bottom: 70px;
  }

  h2 {
    font-size: 36px;
    margin-bottom: 60px;
  }
}

/* Responsive Styles */
@media only screen and (max-width: 767px) {
  .success-single-item {
    padding: 0 8px; // Slightly less padding on small devices
  }

  .success-content {
    margin-left: 0;

    .object {
      margin-bottom: 20px;
    }

    h2 {
      font-size: 25px;
      margin-bottom: 20px;
    }
  }

  .success-single-item .success-content {
    h3 {
      font-size: 20px;
    }

    span {
      font-size: 15px;
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
  .success-content {
    margin-left: 0;
  }
}
.success-stories-area {
  padding-top: 180px; // Adds space below navbar
  padding-bottom: 75px;}
</style>
